import axios from 'axios'; 
import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

const ColorAdd = () => {
  const navigate = useNavigate();

  const initialFormState = {
    color_name: "",
    code: "",   // <-- this is the correct key
    status: "",
  };

  const [ColorUser, setColorUser] = useState(initialFormState);

  const handleInput = (e) => {
    const { name, value } = e.target;
    setColorUser({ ...ColorUser, [name]: value });
  };

  const submitForm = async (e) => {
    e.preventDefault();

    try {
      const response = await axios.post(
        "https://cyberathon.com/multivendor/index.php/Api/Master_controller/add_mst_prod_color",
        ColorUser
      );

      if (response.data.status === true) {
        toast.success(response.data.message || "Color added successfully!");
        navigate("/Color-list");
      } else {
        toast.error(response.data.error || "Failed to add data");
      }

    } catch (error) {
      console.error("API Error:", error);
      toast.error("Something went wrong!");
    }
  };

  return (
    <div className="page-content">
      <div className="container-fluid">

        {/* Page Title */}
        <div className="row">
          <div className="col-12">
            <div className="page-title-box">
              <h4 className="mb-0 fw-semibold">Color Add Page</h4>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item"><a href="#">Master</a></li>
                <li className="breadcrumb-item active">Color Add Page</li>
              </ol>
            </div>
          </div>
        </div>

        <div className='row'>
          <div className="col-md-12">
            <div className="card">
              <div className="card-header">
                <h5>Add New Color</h5>
              </div>

              <form onSubmit={submitForm}>
                <div className="card-body">

                  <div className="mb-3">
                    <label className="form-label">Color Name</label>
                    <input
                      type="text"
                      className="form-control"
                      value={ColorUser.color_name}
                      name='color_name'
                      onChange={handleInput}
                      placeholder="Enter Color Name"
                      required
                    />
                  </div>

                  <div className="mb-3">
                    <label className="form-label">Color Code</label>
                    <input
                      type="color"
                      className="form-control form-control-color"
                      value={ColorUser.code}   // FIXED
                      name='code'              // FIXED
                      onChange={handleInput}
                      required
                    />
                  </div>

                  <div className="mb-3">
                    <label className="form-label">Status</label>
                    <select
                      className="form-control"
                      value={ColorUser.status}
                      name='status'
                      onChange={handleInput}
                      required
                    >
                      <option value="">Select Status</option>
                      <option value="Active">Active</option>
                      <option value="Inactive">Inactive</option>
                    </select>
                  </div>

                  <button className="btn btn-primary" type='submit'>
                    Add Color
                  </button>

                </div>
              </form>

            </div>
          </div>
        </div>

      </div>
    </div>
  );
}

export default ColorAdd;
